import {
  Route,
  Navigate,
  Routes,
  Outlet,
  useNavigate,
  useLocation,
  useSearchParams,
  ScrollRestoration,
} from "react-router-dom";
import React, { useEffect, lazy } from "react";
import { Helmet } from "react-helmet";
import ScrollToHashElement from "@cascadia-code/scroll-to-hash-element";
// import AnalyticsComponent from './components/FirebaseAnalitics/AnaliticsComponent'

//COMPONENTS

//Karrier oldal miatt fontos
// import "uikit/dist/css/uikit.min.css";

//SCSS
import "../src/assets/scss/main.scss";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { jobsData } from "./Pages/Career/Career";
// import Soon from "./Pages/Soon/Soon.js";
// import F1popup from "./components/Popup/F1popup.js";
import ImgViewer from "./components/Gallery/ImgViewer.js";
import FixedBtn from "./components/Button/FixedBtn.js";
import { useDispatch } from "react-redux";
import Otker from "./Pages/Otker/Otker.js";

const About = lazy(() => import("./Pages/About/About"));
const ValentinesModal = lazy(() => import("./Pages/Valentines/ValentinesModal"));

const Nav = lazy(() => import("./components/Partials/Header/Nav.js"));
const Career = lazy(() => import("./Pages/Career/Career"));
const JobItem = lazy(() => import("./Pages/Career/JobItem"));
const ShipCit = lazy(() => import("./Pages/Ship/ShipCit"));
const ShipKisf = lazy(() => import("./Pages/Ship/ShipKisf"));

const CompanyChristmas = lazy(() => import("./Pages/CompanyChristmas/CompanyCristmas"));
// const Maintenance = lazy(() => import("./Pages/Maintenance/Maintenance"));
const ScrollToTop = lazy(() => import("./components/Schroller/ScrollToTop.js"));
// const TripTypes = lazy(() => import("./Pages/Ship/TripTypes"));

const Footer = lazy(() => import("./components/Partials/Footer/Footer.js"));
const ToTop = lazy(() => import("./components/ToTop/ToTop"));
const VRPage = lazy(() => import("./Pages/VRPage/VRPage"));

const Login = lazy(() => import("./Pages/Login/Login"));
const Aug20 = lazy(() => import("./Pages/Aug/Aug20"));

const NewYears = lazy(() => import("./Pages/NewYears/NewYears"));
const DrinkPage = lazy(() => import("./Pages/Drink/DrinkPage"));
const Valentines = lazy(() => import("./Pages/Valentines/Valentines"));
const GalleryPage = lazy(() => import("./Pages/Gallery/GalleryPage"));
const ShipGalleryPage = lazy(() => import("./Pages/Gallery/ShipGalleryPage"));

//PAGES

const GyikPage = lazy(() => import("./Pages/GYIK/index"));
const EventPage = lazy(() => import("./Pages/Rendezvenyek/index"));
const Events = lazy(() => import("./Pages/Events/Events.js"));
const Sights = lazy(() => import("./Pages/Sights/Sights.js"));
const Page404 = lazy(() => import("./Pages/404"));
const HomePage = lazy(() => import("./Pages/Home/home"));

//components

const App = (props) => {
  const language = i18next.language;
  const { t } = useTranslation();
  const location = useLocation();
  const availableLanguages = [
    "hu",
    "en",
    "es",
    "fr",
    "de",
    "it",
    "ru",
    "zh",
    "ro",
    "el",
    "ko",
    "cs",
    "pl",
    "ja",
    "uk",
    "sv",
    "pt",
    "ar",
    "tr",
    "hi",
    "fi",
    "nl",
    "no",
    "hr",
    "sk",
    "vi",
    "da",
    "bg",
    "pt_BR",
  ];
  // useEffect(() => {
  //   const routeLang = window.location.pathname.split("/")[1];
  //   if (routeLang !== language && routeLang.length === 2 && availableLanguages.find((e) => e === routeLang)) {
  //     i18next.changeLanguage(routeLang);
  //   }
  // }, []);
  // useEffect(() => {
  //   i18next.changeLanguage();
  // }, []);

  useEffect(() => {
    location &&
      location.pathname &&
      location.pathname !== "/" &&
      window.fathom &&
      window.fathom.trackPageview({
        url: location.pathname,
      });
    location &&
      location.pathname &&
      location.pathname !== "/" &&
      window.fbq &&
      window.fbq(
        "track",
        "PageView",
        location.search
          ? { url: location.pathname, search: location.search }
          : { url: location.pathname }
      );
  }, [location.pathname]);

  const waitForElement = (id) => {
    const ele = document.getElementById(id);
    if (ele) return ele.scrollIntoView();
    if (!ele) {
      setTimeout(() => {
        waitForElement(id);
      }, 200);
    }
  };
  useEffect(() => {
    if (location.hash) {
      waitForElement([...location.hash].slice(1).join(""));
    }
  }, [location]);
  const setStyle = () => {
    setTimeout(() => {
      const ps = document.getElementsByTagName("p");
      const spans = document.getElementsByTagName("span");
      const hs = document.getElementsByTagName("h2");
      let pArr = Array.from(ps);
      let spanArr = Array.from(spans);
      let hArr = Array.from(hs);
      let arr = [];
      arr.push(...spanArr);
      arr.push(...pArr);
      arr.push(...hArr);
      if (arr.lenth === 0) return setStyle();
      for (let i = 0; i < arr.length; i++) {
        arr[i]?.style.fontWeight < 400
          ? (arr[i].style.fontWeight = 400)
          : (arr[i].style.fontWeight = arr[i].style.fontWeight);
      }
    }, 1000);
  };
  useEffect(() => {
    if (language === "el" || language === "ko" || language === "vi") return setStyle();
  }, [language]);

  const findId = (el) => {
    let count = 0;
    while (!el.id) {
      if (count > 100) return;
      el = el.parentElement;
      count++;
    }
    return el.id;
  };
  useEffect(() => {
    let count = 0;
    const addListener = () => {
      if (count > 10) return;
      const links = document.getElementsByTagName("a");

      if (links.length > 0) {
        setTimeout(() => {
          Array.from(links).forEach((e) => {
            e.addEventListener("click", (f) => {
              let id = findId(f.target);
              window.fathom && window.fathom.trackEvent(`button click: ${id}`);
            });
          });
          return;
        }, 1000);
      } else {
        setTimeout(() => {
          count++;
          addListener();
        }, 2000);
      }
    };
    addListener();
    return () => {
      const links = document.getElementsByTagName("a");
      Array.from(links).forEach((e) => {
        e.removeEventListener("click", (f) => {
          let id = findId(f.target);

          window.fathom && window.fathom.trackEvent(`button click: ${id}`);
        });
      });
    };
  }, []);
  const isValentine = new Date() > new Date("2024/02/14 20:00:00") ? false : true;
  const dispatch = useDispatch();
  useEffect(() => {
    if (location.search.toLowerCase().includes("hardrock")) {
      return dispatch({
        type: "SET_UTM_ORIGIN",
        payload: { code: "HARDROCK25", appliable: "all-week", valid: "2026/05/31" },
      });
    }
    if (location.search.toLowerCase().includes("cityrama")) {
      return dispatch({
        type: "SET_UTM_ORIGIN",
        payload: { code: "CITYRAMA20", appliable: "all-week", valid: "2026/05/31" },
      });
    }
    if (location.search.toLowerCase().includes("madamet")) {
      return dispatch({
        type: "SET_UTM_ORIGIN",
        payload: { code: "MADAMET25", appliable: "all-week", valid: "2026/05/31" },
      });
    }
    return dispatch({
      type: "SET_UTM_ORIGIN",
      payload: { code: "", appliable: "weekdays", valid: null },
    });
  }, []);

  return (
    <>
      <React.StrictMode>
        <Helmet htmlAttributes={{ lang: language }}>
          <meta property="og:title" content={t("head.metaTitle")} />
          <title>{t("head.title")}</title>
          <meta property="og:description" content={t("head.metaDesc")} />
          <meta name="description" content={t("head.desc")} />
          <meta property="og:url" content={window.location} />

          <meta name="facebook-domain-verification" content="cdbg55uh0cwlpm31og4m5sdqn4q3wm" />
        </Helmet>
        <ScrollToHashElement />

        <Nav lang={language} t={t} />
        <div className="page-wrap" id="page-wrap">
          {/* {isValentine && <ValentinesModal />} */}
          {/* <F1popup t={t} lang={language} /> */}
          <div className="payment-error">
            <div>
              <p>{t("main1.notification.payment")} </p>
              <p className="flex">
                <a
                  className="btn"
                  href="https://www.getyourguide.com/budapest-l29/budapest-premium-sightseeing-cruise-with-tokaj-frizzante-t427370/">
                  {t("main1.header.cruise5")}
                </a>
                <a
                  className="btn"
                  href="https://www.getyourguide.com/budapest-l29/budapest-city-lights-evening-cruise-with-audio-guide-t437737/">
                  {t("main1.header.cruise6")}
                </a>
              </p>
            </div>

            <p style={{ textAlign: "center" }}>{t("main1.notification.payment2")}</p>
          </div>
          <ScrollToTop />
          <FixedBtn lang={language} t={t} />
          {/* <ToTop /> */}

          <Routes>
            {/* <Route        
            <ScrollRestoration />
              path="/box-office"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/box-office`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }></Route> */}
            <Route
              path=""
              element={
                <Navigate
                  replace
                  to={{ pathname: `/${language}`, search: location.search, hash: location.hash }}
                />
              }></Route>
            <Route
              path="hableany-drinks-qr-plakett"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/drinks-historical`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }></Route>
            <Route
              path="hableany-drinks"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/drinks-historical`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }></Route>
            <Route
              path={`/${language}/hableany-drinks`}
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/drinks-historical`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }></Route>
            <Route
              path="drinks-hableany"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/drinks-historical`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }></Route>
            <Route
              path={`/${language}/drinks-hableany`}
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/drinks-historical`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }></Route>
            <Route
              path="/events"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/events`,
                    hash: location.hash,
                    search: location.search,
                  }}
                />
              }></Route>
            <Route
              path="/login"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/login`,
                    hash: location.hash,
                    search: location.search,
                  }}
                />
              }></Route>
            <Route
              path="/sights"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/sights`,
                    hash: location.hash,
                    search: location.search,
                  }}
                />
              }></Route>
            <Route
              path="/sights-qr-plakett"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/sights-qr-plakett`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }></Route>
            <Route
              path="/sights-historical"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/sights-historical`,
                    hash: location.hash,
                    search: location.search,
                  }}
                />
              }></Route>
            <Route
              path="/sights-historical-qr-plakett"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/sights-historical-qr-plakett`,
                    hash: location.hash,
                    search: location.search,
                  }}
                />
              }></Route>
            <Route
              path="/hableany-sights"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/hableany-sights`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }></Route>
            <Route
              path="/ticket"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/ticket`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />
            <Route
              path="/karrier/*"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/karrier/`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />
            <Route
              path="/daytime"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/daytime`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />
            <Route
              path="/nighttime"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/nighttime`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />
            <Route
              path="/elegant"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/elegant`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />
            <Route
              path="/citadella"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/elegant`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />
            <Route
              path={`${language}/citadella`}
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/elegant`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />
            <Route
              path="/historical"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/historical`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />
            <Route
              path="/kisfaludy"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/historical`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />
            <Route
              path={`${language}/kisfaludy`}
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/historical`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />
            <Route
              path="/aug20"
              element={
                <Navigate
                  repalce
                  to={{
                    pathname: `/${language}/tuzijatek2024`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />
            <Route
              path="/tuzijatek2024"
              element={
                <Navigate
                  repalce
                  to={{
                    pathname: `/${language}/tuzijatek2024`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />
            <Route
              path={`/${language}/aug20`}
              element={
                <Navigate
                  repalce
                  to={{
                    pathname: `/${language}/tuzijatek2024`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />
            <Route
              path="/drinks"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/drinks`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />
            <Route
              path="/drinks-historical"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/drinks-historical`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />
            <Route
              path="/drinks-historical-qr-plakett"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/drinks-historical-qr-plakett`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />
            <Route
              path="/gallery"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/gallery`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />
            <Route
              path="/gallery-elegant"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/gallery-elegant`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />
            <Route
              path="/gallery-historical"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/gallery-historical`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />
            <Route
              path="/drinks-qr-plakett"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/drinks-qr-plakett`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />
            <Route
              path="/newyears"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/newyears`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />
            {/* <Route
              path="/valentines"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/valentines2024`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />
            <Route
              path="/valentines2024"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/valentines2024`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />
            <Route
              path={`${language}/valentines`}
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/valentines2024`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />
            <Route
              path={`${language}/valentines2024`}
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/valentines2025`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            /> */}
            <Route
              path="/about"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/about`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />
            <Route
              path="/xmas"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/christmas2024`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />{" "}
            <Route
              path="/5ker"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/hu/5ker`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />
            <Route
              path="/christmas2024"
              element={
                <Navigate
                  replace
                  to={{
                    pathname: `/${language}/christmas2024`,
                    search: location.search,
                    hash: location.hash,
                  }}
                />
              }
            />
            <Route path="/hu/5ker" element={<Otker t={t} lang={language} />} />
            {availableLanguages.map((e, i) => (
              <Route key={i} path={e} element={<Outlet style={{ minHeight: "100vh" }} />}>
                <Route path="events" element={<EventPage t={t} />} />
                <Route path="drinks" element={<DrinkPage ship="citadella" />} />
                <Route path="drinks-qr-plakett" element={<DrinkPage ship="citadella" />} />
                {/* <Route path="hableany-drinks-qr-plakett" element={<DrinkPage ship="hableany" />} />
                <Route path="hableany-drinks" element={<DrinkPage ship="hableany" />} /> */}
                <Route path="drinks-historical" element={<DrinkPage ship="hableany" />} />
                <Route
                  path="drinks-historical-qr-plakett"
                  element={<DrinkPage ship="hableany" />}
                />
                <Route path="gallery" element={<GalleryPage />} />
                <Route path="gallery-elegant" element={<ShipGalleryPage tripType="elegant" />} />
                <Route
                  path="gallery-historical"
                  element={<ShipGalleryPage tripType="historical" />}
                />
                <Route path="elegant" element={<ShipCit />} />
                <Route path="historical" element={<ShipKisf />} />
                <Route
                  path="img"
                  element={
                    <>
                      <Helmet>
                        <meta name="robots" content="noindex" />
                      </Helmet>
                      <ImgViewer />
                    </>
                  }
                />
                {/* <Route path="valentines2025" element={<Valentines />} /> */}
                {/* <Route path={`nighttime`} element={<TripTypes tripType="nighttime" />} />
                <Route path={`daytime`} element={<TripTypes tripType="daytime" />} /> */}
                <Route path={"karrier"} element={<Career t={t} />}>
                  {jobsData.map((e, i) => (
                    <Route key={i} path={e.path} element={<JobItem t={t} job={e} index={e.id} />} />
                  ))}
                </Route>

                <Route path={`vrtour-citadella`} element={<VRPage ship="cit" />} />
                <Route path={`vrtour-kisfaludy`} element={<VRPage ship="kf" />} />
                <Route path="about" element={<About t={t} lang={language} />}></Route>
                <Route path="faq" element={<GyikPage {...props} />}></Route>
                {/* <Route path="5ker" element={<Otker t={t} lang={language} />}></Route> */}

                <Route
                  path="sights"
                  element={<Sights ship="citadella" t={t} lang={language} />}></Route>
                <Route
                  path="sights-qr-plakett"
                  element={<Sights ship="citadella" t={t} lang={language} />}></Route>
                <Route
                  path="hableany-sights"
                  element={<Sights ship="hableany" t={t} lang={language} />}></Route>
                <Route
                  path="sights-historical"
                  element={<Sights ship="hableany" t={t} lang={language} />}></Route>
                <Route
                  path="sights-historical-qr-plakett"
                  element={<Sights ship="hableany" t={t} lang={language} />}></Route>
                <Route path={`christmas2024`} element={<CompanyChristmas />}></Route>
                <Route path={`login`} element={<Login />}></Route>
                <Route path={`tuzijatek2024`} element={<Aug20 />}></Route>
                <Route path={`newyears`} element={<NewYears />}></Route>

                <Route path={""} element={<HomePage lang={language} t={t} />} />
              </Route>
            ))}
            <Route path="*" element={<Page404 />} />
          </Routes>
          <Footer lang={language} />
        </div>
      </React.StrictMode>
    </>

    // :
    // <Maintenance />
    // Karbantartásnál
  );
};

export default App;
